import { Middleware } from 'redux';

import {
  successCreateMember,
  successDestroyMember,
  successInviteMember,
  successReadMembersAll,
  successSigninMember,
  successUpdateAccount,
  successUpdateMember
} from '../actions/member';
import {
  failCalling,
  finishCalling,
  noInternetCalling,
  startCalling
} from '../actions/network';
import DeleteMember from '../apis/DeleteMember';
import GetMembersAll from '../apis/GetMembersAll';
import GetResetPassword from '../apis/GetResetPassword';
import InviteMember from '../apis/InviteMember';
import PostMember from '../apis/PostMember';
import PutMember from '../apis/PutMember';
import SigninMember from '../apis/SigninMember';
import IndexedDB from '../common/IndexedDB';

const MIDDLEWARE = 'members';

const membersMiddleware: Middleware = store => next => action => {
  switch (action.type) {
    case 'READ_MEMBERS_ALL':
      readMembersAll(store, action);
      break;

    case 'RESET_PASSWORD_EMAIL':
      resetPasswordEmail(store, action);
      break;

    case 'CREATE_MEMBER':
      createMember(store, action);
      break;

    case 'UPDATE_MEMBER':
      updateMember(store, action);
      break;

    case 'DESTROY_MEMBER':
      destroyMember(store, action);
      break;

    case 'INVITE_MEMBER':
      inviteMember(store, action);
      break;

    case 'SIGNIN_MEMBER':
      signinMember(store, action);
      break;
  }
  next(action);
};

const readMembersAll = (store: any, action: any) => {
  const METHOD = 'readMembersAll';
  console.log(MIDDLEWARE + ':' + 'Call API: GetMembersAll');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetMembersAll();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(store.getState().Account).then(
        members => {
          store.dispatch(successReadMembersAll(members));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const createMember = (store: any, action: any) => {
  const METHOD = 'createMember';
  console.log(MIDDLEWARE + ':' + 'Call API: PostMember');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new PostMember();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.member, store.getState().Account).then(
        member => {
          const db = new IndexedDB();
          db.put('login', member, 'auth');

          store.dispatch(successCreateMember(member));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const updateMember = (store: any, action: any) => {
  const METHOD = 'updateMember';
  console.log(MIDDLEWARE + ':' + 'Call API: PutMember');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new PutMember();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.member, store.getState().Account).then(
        member => {
          if (member.id === store.getState().Account.id) {
            const db = new IndexedDB();
            member.token = store.getState().Account.token;
            db.put('login', member, 'auth');
            store.dispatch(successUpdateAccount(member));
          } else {
            store.dispatch(successUpdateMember(member));
          }

          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const destroyMember = (store: any, action: any) => {
  const METHOD = 'destroyMember';
  console.log(MIDDLEWARE + ':' + 'Call API: DeleteMember');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new DeleteMember();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.member, store.getState().Account).then(
        member => {
          store.dispatch(successDestroyMember(action.member));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const resetPasswordEmail = (store: any, action: any) => {
  const METHOD = 'resetPasswordEmail';
  console.log(MIDDLEWARE + ':' + 'Call API: ResetPasswordEmail');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetResetPassword();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.member).then(
        () => {
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const inviteMember = (store: any, action: any) => {
  const METHOD = 'inviteMember';
  console.log(MIDDLEWARE + ':' + 'Call API: InviteMember');

  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new InviteMember();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.member, store.getState().Account).then(
        member => {
          store.dispatch(successInviteMember(member));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          console.log('InviteMember failed:', errorMessage);
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const signinMember = (store: any, action: any) => {
  const METHOD = 'signinMember';
  console.log(MIDDLEWARE + ':' + 'Call API: SigninMember');

  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new SigninMember();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.member).then(
        member => {
          console.log('SigninMember got:', member);
          const db = new IndexedDB();
          db.put('login', member, 'auth');
          store.dispatch(successSigninMember(member));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          console.log('LoginUser failed:', errorMessage);
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

export default membersMiddleware;



// WEBPACK FOOTER //
// ./src/middlewares/members.ts